const options = {
    grabCursor: true,
    keyboard: true,
    slideToClickedSlide: true,
    navigation: {
        prevEl: '.js-tab-navigation-slider-prev',
        nextEl: '.js-tab-navigation-slider-next',
        disabledClass: 'hidden',
    },
    spaceBetween: 10,
    slidesPerView: 1.1,
    centeredSlides: true,
    breakpoints: {
        768: {
            slidesPerView: 3.1,
            spaceBetween: 10,
            autoHeight: false,
            centeredSlides: false,
        },
        1350: {
            slidesPerView: 4,
            spaceBetween: 0,
            autoHeight: false,
            centeredSlides: false,
        },
    },
};

const sliderTabNavigation = {
    init() {
        const elements = document.querySelectorAll('.js-tab-navigation-slider');

        if (!elements.length) return;

        this.sliderTabNavigation = [];
        elements.forEach((element) => {
            const Slider = slider.default;
            this.sliderTabNavigation.push(new Slider(element, options));
        });
    },
};

export default sliderTabNavigation;
